import { lazy } from "react";

import type { RouteConfig } from "../types";

const DevDebugView = lazy(() => import("views/_dev-debug"));
const DevATokenView = lazy(() => import("views/_dev-a-token"));
const LandXTokenView = lazy(() => import("views/land-x-token"));
const OwnerDashboardView = lazy(() => import("views/owner-dashboard"));
const OauthWorkosLoginView = lazy(() => import("views/oauth-workos-login"));

export const getPublicRoutes = (): RouteConfig[] => [
  { path: "/_dev/debug", component: DevDebugView },
  { path: "/_dev/a/:token", component: DevATokenView },
  { path: "/land-x/:token", component: LandXTokenView },
  { path: "/owner", component: OwnerDashboardView },
  { path: "/oauth/workos/login", component: OauthWorkosLoginView }
];
